import React, { forwardRef } from 'react'

import { CurrencyEurIcon, CurrencyGbpIcon, CurrencyUsdIcon } from '@arcade/web/icons/react'

import { ArcadeHelpTextComponentProps } from '../Arcade/Input/ArcadeHelpText'
import ArcadeInput, { ArcadeInputProps } from '../Arcade/Input/ArcadeInput'

export type CurrencySymbol = '$' | '£' | '€'

export interface CashtagInputProps extends Omit<ArcadeInputProps, 'type'>, ArcadeHelpTextComponentProps {
  /**
   * @default '$'
   */
  currencySymbol?: CurrencySymbol
  placeholder: string
  ariaLabel?: string
}

const DEFAULT_CURRENCY_SYMBOL: CurrencySymbol = '$'

const CURRENCY_ICON_MAP = {
  $: CurrencyUsdIcon,
  '£': CurrencyGbpIcon,
  '€': CurrencyEurIcon,
} as const

const CashtagInput = forwardRef<HTMLInputElement, CashtagInputProps>(
  ({ ariaLabel, currencySymbol = DEFAULT_CURRENCY_SYMBOL, placeholder, value, ...restProps }, ref) => {
    const LeadingIcon = CURRENCY_ICON_MAP[currencySymbol] as ArcadeInputProps['LeadingIcon']
    const resolvedAriaLabel = ariaLabel ?? `${currencySymbol}cashtag`

    return (
      <ArcadeInput
        aria-label={resolvedAriaLabel}
        {...restProps}
        autoCapitalize="off"
        autoComplete="off"
        autoCorrect="off"
        LeadingIcon={LeadingIcon}
        placeholder={placeholder}
        ref={ref}
        spellCheck={false}
        type="text"
        value={value}
      />
    )
  }
)

CashtagInput.displayName = 'CashtagInput'

export default CashtagInput
